<div class="share-event-dialog">
  <div class="dialog-header">
    <h2>{{ 'translations.shareCourseEvent' | transloco }}</h2>
    <button mat-icon-button (click)="closeDialog()" class="close-button">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <div class="share-options">
      <div class="share-option">
        <button mat-button class="share-button" (click)="openNewMomentDialog()">
          <mat-icon>share</mat-icon>
          {{ 'translations.global.button.post' | transloco }}
        </button>
      </div>

      <div class="share-option">
        <div class="copy-link-container">
          <div class="share-input">
            <input type="text" id="copyLink" [value]="shareUrl" readonly class="url-input" />
            <button
              mat-icon-button
              class="copy-btn"
              color="accent"
              [attr.aria-label]="'translations.global.ariaLabels.tapToCopyLink' | transloco"
              (click)="copyLink()"
            >
              <svg class="svg svg-icon" aria-hidden="true">
                <use ogSvgUnify="assets/sprite/sprite.svg#copy"></use>
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
